module.exports = __webpack_public_path__ + "assets/img/0.0961d330.png";